import axios, { AxiosError } from 'axios';
import { requestInterceptor } from '@ilteducation/ilt-auth';
import * as datadog from '@ilteducation/datadog';

export default function setup() {
  axios.interceptors.request.use(requestInterceptor);
  if (!process.env.VITE_DISABLE_DATADOG) {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (axios.isAxiosError(error)) {
          const ae: AxiosError = error as AxiosError;
          const context = {
            url: ae.response?.config.url,
            status: ae.response?.status,
            statusText: ae.response?.statusText,
            method: ae.response?.config.method,
          };
          datadog.report(error, context);
        }
        return Promise.reject(error);
      },
    );
  }
}
